import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import axios from "axios";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";

import { useHistory } from "react-router-dom";
import dayjs from "dayjs";
const useEmpLTP = (formData, workflowDetails) => {
  const subTabLabels = [
    { label: "Applicant Type" },
    { label: "Applicant Details" },
    { label: "Contact Information" },
    { label: "Registration Details" },
    // { label: "Document Details" },
  ];
  const Modal = useModal();
  const today = dayjs();
  const fiveYearsFromNow = today.add(5, "year");
  const history = useHistory();
  const tenantId = Digit.ULBService.getStateId();
  const tradeType = formData?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType;
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "Registration");
  let user = Digit.UserService.getUser();
  const [currentAction, setCurrentAction] = useState("");
  const [developerRemarks, setDeveloperRemarks] = useState("");
  const reduxFormData = useSelector((state) => state?.ltpChecklist);
  const [updatedDocuments, setUpdatedDocuments] = useState(formData?.tradeLicenseDetail?.applicationDocuments);
  const [documentRemarksData, setDocumentRemarksData] = useState({});
  const [uploadedFile, setUploadedFile] = useState(null);
  const [file, setFile] = useState(null);
  const [callAPI, setCallAPI] = useState(false);
  const [validUpTo, setValidUpto] = useState(null);
  const [showTakeAction, setShowTakeAction] = useState("");
  const [structureCertificateUrl, setStructureCertificateUrl] = useState("");
  const [loader, setLoader] = useState(false);
  const [dataRecommendationDocument, setDataRecommendationDocument] = useState("");
  const [developerRemarksDocument, setDeveloperRemarksDocument] = useState(null);
  const [developerUpdateDocument, setDeveloperUpdateDocument] = useState("");
  const [structureCertificateId, setStructureCertificateId] = useState("");
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("EMP_LTP", formData);
  const [iframeSrc, setIframeSrc] = useState("");
  const userRolesArray = user?.info?.roles.filter((user) => user.code !== "EMPLOYEE");
  const isNodal = userRolesArray?.some((e) => e?.code === "Nodal Officer");
  const isAwasOfficer = userRolesArray?.some((e) => e?.code === "NODAL_OFFICER_AWAS");
  const userInfo = Digit.UserService.getUser()?.info || {};
  const authToken = Digit.UserService.getUser()?.access_token || null;
  function selectFile(e) {
    setFile(e.target.files[0]);
  }

  const handleGetDocumentById = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.bpaService.remarksDocument}&applicationNo=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setDocumentRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  // const callDocumentDetailsAPI = async (developerRemarks,dataRecommendation) => {
  //   console.log("selectedObjection1", dataRecommendationDocument, developerRemarksDocument, updatedDocuments?.[0]?.documentRemarks);

  //   setLoader(true);
  //   const postData = {
  //     RequestInfo: {
  //       apiId: "Rainmaker",
  //       authToken: authToken,
  //       userInfo: userInfo,
  //       msgId: "1743578637716|en_IN",
  //     },
  //     DetailDataRemarks: {
  //       userDetails: {
  //         userID: userInfo?.id || null,
  //         name: userInfo?.name || null,
  //         employeeName: userInfo?.name || null,
  //         role: userRolesArray?.[0]?.code,
  //         applicationID: formData?.applicationNumber,
  //         designation: userRolesArray?.[0]?.name,
  //         applicationStatus: formData?.status,
  //       },
  //       isApproved: "DocumentDetails",
  //       documentDetails: {
  //         dataRecommendation: dataRecommendationDocument,
  //         developerRemarks: developerRemarksDocument,
  //         documents: updatedDocuments,
  //       },
  //     },
  //   };

  //   try {
  //     const Resp = await axios.post(Urls.bpaService.remarksDetail, postData, {}).then((response) => {
  //       console.log("log1223", Resp, response.data);
  //       return response.data;
  //     });
  //     setLoader(false);
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   Modal(`Documents updated`, `Document details for <strong>(${formData?.applicationNumber})</strong> updated successfully!`, "success");
  //   // Modal("Documents remarks saved.", `Remarks for <strong>${formData?.applicationNumber}</strong> saved successfully`, "success");
  //   await handleGetDocumentById(formData?.applicationNumber);
  //   // handleChange(undefined, "2");
  // };

  // useEffect(() => {
  //   if (
  //     dataRecommendationDocument &&
  //     developerRemarksDocument &&
  //     updatedDocuments?.filter((doc) => doc.isMandatory)[0]?.documentRemarks &&
  //     developerUpdateDocument === "DocumentDetailsUpdated"
  //   ) {
  //     callDocumentDetailsAPI();
  //   }
  // }, [dataRecommendationDocument, developerRemarksDocument, updatedDocuments?.[0]?.documentRemarks, developerUpdateDocument]);

  const callDocumentDetailsAPI = async (developerRemarks, dataRecommendation, documents) => {
    const finalRecommendation = dataRecommendation !== undefined && dataRecommendation !== null ? dataRecommendation : dataRecommendationDocument;

    const finalRemarks = developerRemarks !== undefined && developerRemarks !== null ? developerRemarks : developerRemarksDocument;

    const finalDocuments = documents !== undefined && documents !== null ? documents : updatedDocuments;

    if (!finalRecommendation || !finalRemarks || !finalDocuments || finalDocuments.length === 0) {
      console.log("Data not ready, API blocked");
      return;
    }

    setLoader(true);

    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN",
      },

      DetailDataRemarks: {
        userDetails: {
          userID: userInfo && userInfo.id ? userInfo.id : null,
          name: userInfo && userInfo.name ? userInfo.name : null,
          employeeName: userInfo && userInfo.name ? userInfo.name : null,
          role: userRolesArray && userRolesArray[0] ? userRolesArray[0].code : null,
          applicationID: formData ? formData.applicationNumber : null,
          designation: userRolesArray && userRolesArray[0] ? userRolesArray[0].name : null,
          applicationStatus: formData ? formData.status : null,
        },

        isApproved: "DocumentDetails",

        documentDetails: {
          dataRecommendation: finalRecommendation,
          developerRemarks: finalRemarks,
          documents: finalDocuments,
        },
      },
    };

    try {
      const response = await axios.post(Urls.bpaService.remarksDetail, postData);

      console.log("response", response.data);

      Modal("Documents updated", `Document details for <strong>(${formData.applicationNumber})</strong> updated successfully!`, "success");

      await handleGetDocumentById(formData.applicationNumber);
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (callAPI && updatedDocuments?.length > 0 && dataRecommendationDocument && developerRemarksDocument) {
      callDocumentDetailsAPI(developerRemarksDocument, dataRecommendationDocument);

      setCallAPI(false); // reset after one hit
    }
  }, [callAPI, updatedDocuments, dataRecommendationDocument, developerRemarksDocument]);

  useEffect(() => {
    console.log("applicationRemarksFetch", formData?.applicationNumber);
    if (formData?.applicationNumber) {
      handleGetDocumentById(formData.applicationNumber);
    }
  }, [formData?.applicationNumber]);

  useEffect(() => {
    console.log(documentRemarksData, documentRemarksData?.DetailDataRemarks?.[0]?.documentDetails?.dataRecommendation, "documentRemarksData");

    if (documentRemarksData?.DetailDataRemarks) {
      setDataRecommendationDocument(documentRemarksData?.DetailDataRemarks?.[0]?.documentDetails?.dataRecommendation || "");
      setDeveloperRemarksDocument(documentRemarksData?.DetailDataRemarks?.[0]?.documentDetails?.developerRemarks || "");
    }
  }, [documentRemarksData?.DetailDataRemarks]);

  useEffect(() => {
    // const isDocValidated = formData?.tradeLicenseDetail?.applicationDocuments?.some((item) => item.documentRemarks !== null);

    const userId = String(user?.info?.id);

    const detailData = documentRemarksData?.DetailDataRemarks?.[0];

    const detailUserId = String(detailData?.userDetails?.userID);

    const matchedData = detailUserId === userId;

    const isDocValidated = matchedData && Array.isArray(detailData?.documentDetails?.documents) && detailData.documentDetails.documents.length > 0;

    console.log("userId", userId);
    console.log("detailUserId", detailUserId);
    console.log("matchedData", matchedData);
    console.log("documents", detailData?.documentDetails?.documents);
    console.log("isDocValidated", isDocValidated);

    Digit?.SessionStorage.set("isDocValidated", isDocValidated);
  }, [user, documentRemarksData]);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };
  const allValuesNull = (data) => Object.values(data || {}).every((value) => value === null);
  const viewApprovalLetter = (url) => {
    const fileUrl = structureCertificateUrl || url;
    window.open(fileUrl, "_blank");
    Swal.fire({
      title: "Action Approved",
      text: `Application Approved Successfully!`,
      icon: "success",
    }).then(() => {
      window.location.reload();
    });
    history.push("/digit-ui/employee");
  };
  const handleSubmit = async () => {
    if (isNodal && allValuesNull(reduxFormData)) {
      Swal.fire({
        title: "Checklist Required",
        text: `Please fill the checklist before Proceeding!`,
        icon: "error",
      });
      return 0;
    }
    // const isDocValidated = Digit?.SessionStorage?.get("isDocValidated");
    const userId = String(user?.info?.id);

    const detailData = documentRemarksData?.DetailDataRemarks?.[0];

    const detailUserId = String(detailData?.userDetails?.userID);

    const matchedData = detailUserId === userId;

    // const isDocValidated =
    //   matchedData &&
    //   Array.isArray(detailData?.documentDetails?.documents) &&
    //   detailData.documentDetails.documents.length > 0;

    const isDocValidated =
      Array.isArray(detailData?.documentDetails?.documents) &&
      detailData.documentDetails.documents.length > 0 &&
      (isAwasOfficer ? true : matchedData);

    console.log("matchedData346", matchedData, detailData, user);

    // console.log("userId", userId);
    // console.log("detailUserId", detailUserId);
    // console.log("matchedData", matchedData);
    // console.log("documents", detailData?.documentDetails?.documents);
    // console.log("isDocValidated", isDocValidated);

    Digit?.SessionStorage.set("isDocValidated", isDocValidated);

    if (!isDocValidated) {
      Modal("Review documents section", "Please review the documents section and click on Save", "error");
      return;
    }
    if (!currentAction?.action) {
      Modal("Please select the action", "Please select the available action to proceed further", "error");
      return;
    }
    if (!validUpTo) {
      Modal("Validity Date Missing", "Please select a valid up to date from date picker", "error");
      return;
    }
    if (isAwasOfficer && formData?.status === "APPLY_FOR_DSC" && !formData?.IsApprovalCertificate) {
      Modal("Digital signature not attached", "Please make sure digital signature is successfully attached", "error");
      return;
    }
    try {
      const additionalDetails = { ...params };
      const workflow = {
        action: currentAction?.action,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...params,
        validupto: validUpTo,
        // documents: formData?.applicationData?.tradeLicenseDetail?.applicationDocuments ,
        tradeLicenseDetail: {
          ...formData?.tradeLicenseDetail,
          // applicationDocuments: updatedDocuments,
        },

        additionalDetails,
        workflow,
        action: currentAction?.action,
        comment: developerRemarks,
        nocOtherDetails: reduxFormData,
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: currentAction?.action + " DOC",
                fileName: uploadedFile?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const data = [{ ...appData }];
      console.log("dataLtp", data);

      updateApiCall.mutate(
        { Licenses: data },
        {
          onSuccess: async (result) => {
            if (result?.Licenses?.length > 0) {
              Modal(
                `Application updated`,
                `Action taken successfully for Application <strong>(${result?.Licenses?.[0]?.applicationNumber})</strong>!`,
                "success",
                "/digit-ui/employee"
              );
              const fileStoreId = result?.Licenses?.[0]?.approvalLetterId;
              const fileStoreUrl = result?.Licenses?.[0]?.approvalLetterUrl;
              setStructureCertificateId(fileStoreId);
              setStructureCertificateUrl(fileStoreUrl);
              setShowTakeAction("Take_Action");
              Digit.SessionStorage.del("EMP_LTP");
              Digit?.SessionStorage.del("isDocValidated");
            }
          },
        }
      );
    } catch (error) {
      console.log(error);
    }
  };
  const handleNoWorkflow = (updatedDocuments) => {
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    const appData = {
      ...formData,
      tradeLicenseDetail: { ...formData?.tradeLicenseDetail, applicationDocuments: updatedDocuments },
      action: "NOWORKFLOW",
      workflow,
      //   documents: updatedDocuments,
      // taxHeadEstimates: [...formData?.taxHeadEstimates, ...taxHeadData] || [],
      // inspectionDetailData:
      //     userRolesArray?.[0]?.code === "JE"
      //         ? data
      //         : formData?.inspectionDetailData,
    };
    const data = [{ ...appData }];
    updateApiCall.mutate(
      { Licenses: data },
      {
        onSuccess: (result) => {
          console.log("resultFromUpdate", result);
          setDeveloperUpdateDocument("DocumentDetailsUpdated");
          onSelect("", result?.Licenses?.[0]);
          //   onSelect("", result?.BPA?.[0]);
          // const isDocValidated = result?.BPA?.[0]?.documents?.some((item) => item.documentRemarks !== null);
          Digit?.SessionStorage.set("isDocValidated", true); // Modal(`Application updated.`, `Application Updated Successfully!`, "success", "/digit-ui/employee");
          // Modal(`Documents updated`, `Document details for <strong>(${formData?.applicationNumber})</strong> updated successfully!`, "success");
        },
      }
    );
  };
  const docs = formData?.applicationData?.tradeLicenseDetail?.applicationDocuments || {};

  const documents = typeof docs === "object" && !Array.isArray(docs) ? Object.values(docs) : docs;
  let improvedDoc = [];
  formData?.PrevStateDocuments?.map((preDoc) => {
    improvedDoc.push({ ...preDoc, module: "OBPS" });
  });
  documents?.map((appDoc) => {
    improvedDoc.push({ ...appDoc, module: "OBPS" });
  });

  formData?.PrevStateNocDocuments?.map((preNocDoc) => {
    improvedDoc.push({ ...preNocDoc, module: "NOC" });
  });
  formData?.nocDocuments?.nocDocuments?.map((nocDoc) => {
    improvedDoc.push({ ...nocDoc, module: "NOC" });
  });
  const documentSection = formData?.tradeLicenseDetail?.applicationDocuments?.filter(
    (doc) => !["signature", "applicantPhoto", "typeOfLetterDoc"].includes(doc.documentType)
  );
  const { data: pdfDetails, isLoading: pdfLoading } = Digit.Hooks.useDocumentSearch(improvedDoc, { enabled: improvedDoc?.length > 0 ? true : false });
  const fetchInitialUrl = async (fileStoreId) => {
    const response = await axios.get(`/filestore/v1/files/url?tenantId=up&fileStoreIds=${fileStoreId}`);
    // console.log("responseFromFileStore", response.data.fileStoreIds[0].url);
    // setInitialUrl(response.data.fileStoreIds[0].url);
    setIframeSrc(response.data.fileStoreIds[0].url);
    // return response.data.fileStoreIds[0].url || "";
  };
  useEffect(() => {
    console.log("documentLTPSECTION", documentSection);
    if (documentSection?.[0]?.fileStoreId) {
      fetchInitialUrl(documentSection?.[0]?.fileStoreId);
    }
  }, []);
  //   useEffect(() => {
  //     console.log("sessionSettingCalled");

  // Digit.SessionStorage.set("EMP_LTP", formData);

  //   }, []);
  let applicationDocs = [],
    nocAppDocs = [];
  if (pdfDetails?.pdfFiles?.length > 0) {
    pdfDetails?.pdfFiles?.map((pdfAppDoc) => {
      if (pdfAppDoc?.module == "OBPS") applicationDocs.push(pdfAppDoc);
      if (pdfAppDoc?.module == "NOC") nocAppDocs.push(pdfAppDoc);
    });
  }
  const userRoles = user?.info?.roles?.map((e) => e.code);
  let isbelow = formData?.plotArea < 2500;
  const isTCP = userRoles.includes("TCP_HQ") || userRoles.includes("TCP");
  let actions = workflowDetails?.data?.actionState?.nextActions?.filter((e) => {
    if (isbelow && isTCP && (e.action === "SEND_TO_STP" || e.action === "FORWARD") && formData?.businessService === "BPA") {
      return false;
    } else if (
      !isbelow &&
      isTCP &&
      (e.action === "APPROVE" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECT" || e.action === "PROVISIONALLY_APPROVAL") &&
      formData?.businessService === "BPA"
    ) {
      return false;
    }
    return userRoles.some((role) => e.roles?.includes(role)) || !e.roles;
  });
  console.log("actiaonsLTP", actions);

  const onDropDownSelect = (event) => {
    const value = event.target.value;

    setCurrentAction(value);
  };
  let consumerCode = formData?.applicationNo;
  const fetchBillParams = { consumerCode };
  const appType = formData?.applicationType;
  const BusinessService = formData?.businessService === `BPA_${appType?.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;

  const { data: paymentDetails } = Digit.Hooks.useFetchBillsForBuissnessService(
    { businessService: BusinessService, ...fetchBillParams, tenantId },
    {
      enabled: consumerCode ? true : false,
      retry: false,
    }
  );
  const totalAmount = formData?.paymentDetails?.bill?.billDetails[0]?.amount || paymentDetails?.Bill?.[0]?.billDetails[0]?.amount;
  const isCitizen = user?.info?.type === "CITIZEN";
  return {
    subTabLabels,
    tradeType,
    isCitizen,
    params,
    setParams,
    clearParams,
    onSelect,
    updateApiCall,
    currentAction,
    setCurrentAction,
    developerRemarks,
    setDeveloperRemarks,
    uploadedFile,
    setUploadedFile,
    handleNoWorkflow,
    applicationDocs,
    totalAmount,
    actions,
    onDropDownSelect,
    handleSubmit,
    viewApprovalLetter,
    showTakeAction,
    iframeSrc,
    setIframeSrc,
    updatedDocuments,
    setUpdatedDocuments,
    dataRecommendationDocument,
    setDataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    callDocumentDetailsAPI,
    documentRemarksData,
    developerUpdateDocument,
    setValidUpto,
    fiveYearsFromNow,
  };
};
export default useEmpLTP;
